export default "__VITE_ASSET__Apva81RW__"